/**
 * @swagger
 *  components:
 *    schemas:
 *      Religion:
 *        type: string
 *        description: |
 *          The Religions of the world.
 *
 *          `african-traditional-and-diasporic` - African Traditional & Diasporic.
 *
 *          `agnostic` - Agnostic.
 *
 *          `animism` - Animism.
 *
 *          `atheist` - Atheist.
 *
 *          `baha-i` - Baháʼí.
 *
 *          `buddhism` - Buddhism.
 *
 *          `cao-dai` - Cao Dai.
 *
 *          `chinese-traditional-religion` - Chinese Traditional Religion.
 *
 *          `christianity` - Christianity.
 *
 *          `hinduism` - Hinduism.
 *
 *          `islam` - Islam.
 *
 *          `jainism` - Jainism.
 *
 *          `juche` - Juche.
 *
 *          `judaism` - Judaism.
 *
 *          `neo-paganism` - Neo-Paganism.
 *
 *          `nonreligious` - Nonreligious.
 *
 *          `rastafari` - Rastafari.
 *
 *          `secular` - Secular.
 *
 *          `shinto` - Shinto.
 *
 *          `sikhism` - Sikhism.
 *
 *          `spiritism` - Spiritism.
 *
 *          `tenrikyo` - Tenrikyo.
 *
 *          `unitarian-universalism` - Unitarian Universalism.
 *
 *          `zoroastrianism` - Zoroastrianism.
 *
 *          `primal-indigenous` - Primal Indigenous.
 *
 *          `unspecified` - Unspecified (Other).
 *
 *          `undisclosed` - Undisclosed (User prefers not to say).
 *
 *        enum:
 *          - african-traditional-and-diasporic
 *          - agnostic
 *          - animism
 *          - atheist
 *          - baha-i
 *          - buddhism
 *          - cao-dai
 *          - chinese-traditional-religion
 *          - christianity
 *          - hinduism
 *          - islam
 *          - jainism
 *          - juche
 *          - judaism
 *          - neo-paganism
 *          - nonreligious
 *          - rastafari
 *          - secular
 *          - shinto
 *          - sikhism
 *          - spiritism
 *          - tenrikyo
 *          - unitarian-universalism
 *          - zoroastrianism
 *          - primal-indigenous
 *          - unspecified
 *          - undisclosed
 */
/**
 * Religions
 */
export enum Religion {
  /**
   * African Traditional & Diasporic
   */
  AfricanTraditionalAndDiasporic = 'african-traditional-and-diasporic',

  /**
   * Agnostic
   */
  Agnostic = 'agnostic',

  /**
   * Animism
   */
  Animism = 'animism',

  /**
   * Atheist
   */
  Atheist = 'atheist',

  /**
   * Baháʼí
   */
  BahaI = 'baha-i',

  /**
   * Buddhism
   */
  Buddhism = 'buddhism',

  /**
   * Cao Dai
   */
  CaoDai = 'cao-dai',

  /**
   * Chinese Traditional Religion
   */
  ChineseTraditionalReligion = 'chinese-traditional-religion',

  /**
   * Christianity
   */
  Christianity = 'christianity',

  /**
   * Hinduism
   */
  Hinduism = 'hinduism',

  /**
   * Islam
   */
  Islam = 'islam',

  /**
   * Jainism
   */
  Jainism = 'jainism',

  /**
   * Juche
   */
  Juche = 'juche',

  /**
   * Judaism
   */
  Judaism = 'judaism',

  /**
   * Neo-Paganism
   */
  NeoPaganism = 'neo-paganism',

  /**
   * Nonreligious
   */
  Nonreligious = 'nonreligious',

  /**
   * Rastafari
   */
  Rastafari = 'rastafari',

  /**
   * Secular
   */
  Secular = 'secular',

  /**
   * Shinto
   */
  Shinto = 'shinto',

  /**
   * Sikhism
   */
  Sikhism = 'sikhism',

  /**
   * Spiritism
   */
  Spiritism = 'spiritism',

  /**
   * Tenrikyo
   */
  Tenrikyo = 'tenrikyo',

  /**
   * Unitarian Universalism
   */
  UnitarianUniversalism = 'unitarian-universalism',

  /**
   * Zoroastrianism
   */
  Zoroastrianism = 'zoroastrianism',

  /**
   * Primal Indigenous
   */
  PrimalIndigenous = 'primal-indigenous',

  /**
   * Unspecified (Other)
   */
  Unspecified = 'unspecified',

  /**
   * Undisclosed (I prefer not to say)
   */
  Undisclosed = 'undisclosed',
}
